var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEntityOverviewIllustration = function SvgEntityOverviewIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324,
    height: 250,
    fill: "none",
    viewBox: "0 0 324 250"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#EntityOverviewIllustration_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#EntityOverviewIllustration_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 220,
    x: 21.957,
    y: 8.51,
    fill: "url(#EntityOverviewIllustration_svg__c)",
    rx: 1.737,
    shapeRendering: "crispEdges",
    transform: "rotate(3 21.957 8.51)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 219,
    x: 16.5,
    y: 15.5,
    fill: "url(#EntityOverviewIllustration_svg__d)",
    fillOpacity: 0.56,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 219,
    x: 16.5,
    y: 15.5,
    stroke: "url(#EntityOverviewIllustration_svg__e)",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 4,
    x: 176,
    y: 39,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 4,
    x: 176,
    y: 47,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 4,
    x: 176,
    y: 55,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 4,
    x: 176,
    y: 63,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 4,
    x: 176,
    y: 71,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 4,
    x: 176,
    y: 79,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 4,
    x: 176,
    y: 99,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 4,
    x: 176,
    y: 106,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 4,
    x: 176,
    y: 113,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 4,
    x: 176,
    y: 120,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 4,
    x: 176,
    y: 127,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 4,
    x: 176,
    y: 147,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 4,
    x: 176,
    y: 155,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 4,
    x: 176,
    y: 163,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 4,
    x: 176,
    y: 183,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 4,
    x: 176,
    y: 190,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 4,
    x: 176,
    y: 197,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8598AF",
    d: "M94.646 123.354a.5.5 0 0 0 .708 0l3.182-3.182a.501.501 0 0 0-.708-.708L95 122.293l-2.828-2.829a.5.5 0 0 0-.707.708zM95 93h-.5v30h1V93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516B89",
    d: "M128.646 182.854a.5.5 0 0 0 .708 0l3.182-3.182a.502.502 0 0 0-.708-.708L129 181.793l-2.828-2.829a.502.502 0 0 0-.708.708zM99 166v-.5zm-4-16h-.5v12h1v-12zm4 16v.5h26v-1H99zm30 4h-.5v12.5h1V170zm-4-4v.5a3.5 3.5 0 0 1 3.5 3.5h1a4.5 4.5 0 0 0-4.5-4.5zm-30-4h-.5a4.5 4.5 0 0 0 4.5 4.5v-1a3.5 3.5 0 0 1-3.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516B89",
    d: "M61.354 182.854a.5.5 0 0 1-.708 0l-3.181-3.182a.501.501 0 0 1 .707-.708L61 181.793l2.828-2.829a.5.5 0 0 1 .707.708zM91 166v-.5zm4-16h.5v12h-1v-12zm-4 16v.5H65v-1h26zm-30 4h.5v12.5h-1V170zm4-4v.5a3.5 3.5 0 0 0-3.5 3.5h-1a4.5 4.5 0 0 1 4.5-4.5zm30-4h.5a4.5 4.5 0 0 1-4.5 4.5v-1a3.5 3.5 0 0 0 3.5-3.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 8,
    x: 40,
    y: 39,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 4,
    x: 40,
    y: 51,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 82.979,
    y: 70,
    fill: "#8598AF",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "M91.479 80.5v4m2.25-4v4m2.5-4v4m2.25-4v4m-8 .8v.4c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218c.107.055.247.055.527.055h7.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218c-.107-.055-.247-.055-.527-.055h-7.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.219.218c-.054.107-.054.247-.054.527m4.326-7.761-3.7.822c-.223.05-.335.074-.419.134a.5.5 0 0 0-.167.209c-.04.094-.04.209-.04.438v.558c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218c.107.055.247.055.527.055h7.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-.558c0-.23 0-.344-.04-.438a.5.5 0 0 0-.168-.209c-.084-.06-.195-.085-.419-.134l-3.7-.822a1 1 0 0 0-.13-.025 1 1 0 0 0-.087 0c-.033.003-.065.01-.13.025"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 82.979,
    y: 126,
    fill: "#8598AF",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "M91.479 136.5v4m2.25-4v4m2.5-4v4m2.25-4v4m-8 .8v.4c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218c.107.055.247.055.527.055h7.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.219c-.107-.054-.247-.054-.527-.054h-7.4c-.28 0-.42 0-.527.054a.5.5 0 0 0-.219.219c-.054.107-.054.247-.054.527m4.326-7.761-3.7.822c-.223.049-.335.074-.419.134a.5.5 0 0 0-.167.209c-.04.094-.04.209-.04.438v.558c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218c.107.055.247.055.527.055h7.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-.558c0-.229 0-.344-.04-.438a.5.5 0 0 0-.168-.209c-.084-.06-.195-.085-.419-.134l-3.7-.822a1 1 0 0 0-.13-.025 1 1 0 0 0-.087 0 1 1 0 0 0-.13.025"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 49,
    y: 185,
    fill: "#516B89",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "M65 201.5c0-.698 0-1.047-.086-1.331a2 2 0 0 0-1.333-1.333c-.284-.086-.633-.086-1.331-.086h-2.5c-.698 0-1.047 0-1.33.086a2 2 0 0 0-1.334 1.333c-.086.284-.086.633-.086 1.331m6.25-6.75a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 117,
    y: 185,
    fill: "#516B89",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "M133 201.5c0-.698 0-1.047-.086-1.331a2 2 0 0 0-1.333-1.333c-.284-.086-.633-.086-1.331-.086h-2.5c-.698 0-1.047 0-1.331.086a2 2 0 0 0-1.333 1.333c-.086.284-.086.633-.086 1.331m6.25-6.75a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "EntityOverviewIllustration_svg__c",
    x1: 27.962,
    x2: 150.169,
    y1: 12.861,
    y2: 298.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111827",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EntityOverviewIllustration_svg__d",
    x1: 19.681,
    x2: 150.959,
    y1: 16.212,
    y2: 306.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#385677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EntityOverviewIllustration_svg__e",
    x1: 275,
    x2: 209.219,
    y1: 235,
    y2: 71.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516B89",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "EntityOverviewIllustration_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h324v250H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "EntityOverviewIllustration_svg__b",
    width: 448.99,
    height: 380.857,
    x: -62.495,
    y: -64.429,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 8.683,
    result: "effect1_dropShadow_6_387"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.815,
    dy: 10.42
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.645
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00392157 0 0 0 0 0.0431373 0 0 0 0 0.145098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6_387",
    result: "shape"
  })))));
};
export default SvgEntityOverviewIllustration;